<i18n>
  {
    "fr": {
      "schedules": "Horaires",
      "stopover": "Escales",
      "companies": "Compagnies"
    },
    "en": {
      "schedules": "Schedules",
      "stopover": "Stopovers",
      "companies": "Companies"
    }
  }
</i18n>

<template>
  <v-row class="mt-2">
    <div class="ml-3">
      <FlightSelectLuggage />
    </div>
    <!--<div class="ml-2">-->
    <div class="ml-0">
      <FlightFilterStopover />
    </div>
    <div class="ml-2">
      <FlightFilterSchedules />
    </div>
    <div class="ml-2">
      <FlightFilterAirlineCompany />
    </div>
    <FlightSearchResultsRefreshPopUp />
  </v-row>
</template>

<script>
import FlightFilterSchedules from './FlightFilterSchedules/FlightFilterSchedules'
import FlightFilterStopover from './FlightFilterStopover/FlightFilterStopover'
import FlightFilterAirlineCompany from './FlightFilterAirlineCompany/FlightFilterAirlineCompany'
import FlightSelectLuggage from './FlightSelectLuggage/FlightSelectLuggage'
import FlightSearchResultsRefreshPopUp from '../FlightSearchResultsRefreshPopUp/FlightSearchResultsRefreshPopUp'

export default {
  name: 'FlightSearchResultsFilters',
  components: {
    FlightFilterSchedules,
    FlightFilterStopover,
    FlightFilterAirlineCompany,
    FlightSelectLuggage,
    FlightSearchResultsRefreshPopUp
  }
}
</script>

<style scoped>
</style>
